import React, { useEffect } from 'react'
import { BackButtonDesktop } from './BackButton'
import MediaQuery from 'react-responsive'

import { Logo } from './Logo'
import HeaderWrapper from './HeaderWrapper'

const BasicHeader = () => {
  useEffect(() => {
    document.querySelectorAll('#meu-negocio').length > 0 && document.querySelector('#meu-negocio').focus()
  })

  return (
    <HeaderWrapper className='container-header-basic'>
      <MediaQuery maxWidth={479}>
        <BackButtonDesktop mobile />
      </MediaQuery>
      <Logo />
      <MediaQuery minWidth={480}>
        <BackButtonDesktop />
      </MediaQuery>
      <div className='clear pl-1 order-md-3 order-3 d-flex d-md-none col-2' />
    </HeaderWrapper>
  )
}

export default BasicHeader



// WEBPACK FOOTER //
// ./src/App/Header/BasicHeader.js